import { v4 } from 'uuid';

import { Answer } from '../interfaces';

function createAnswer(
  value: any,
  collectionItemId?: string,
  fileName?: string,
  comment?: string,
  questionType?: string,
): Answer {
  return {
    id: v4(),
    answeredAt: new Date(),
    content: value,
    collectionItemId,
    fileName,
    comment,
    questionType,
  };
}

export { createAnswer };
